import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

// Shared so services outside React components (e.g. ApiGetPersonId) can acquire tokens.
export const msalInstance = new PublicClientApplication(msalConfig);
